// Dictionnaire des données en attente de traitement pour chaque route
const pendingData: Record<string, Record<string, unknown>> = {};

/**
 * Service de navigation pour stocker des données en attente de traitement pour une route donnée
 */
export const NavigationData = {
    // Stocke les données pour une route donnée
    set(route: string, data: Record<string, unknown>): void {
        pendingData[route] = data;
    },

    // Récupère les données pour une route donnée et les supprime de la liste des données en attente
    consume(route: string): Record<string, unknown> | null {
        const data = pendingData[route] ?? null;
        delete pendingData[route];
        return data;
    }
};



// WEBPACK FOOTER //
// ./src/shared/services/navigation.service.ts